import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '../../../shared';
import { useNoDuplicateSupportCase } from '../../hooks';

interface Props {
    subjectId: string;
    targetId: string;
    onClose?: () => void;
}

export const NoDuplicateSupportCase: FC<Props> = ({ subjectId, targetId, onClose }) => {
    const { t } = useTranslation();
    const { mutateAsync: markAsNoDuplicate } = useNoDuplicateSupportCase();

    const onMerge = async () => {
        await markAsNoDuplicate({ subjectId: subjectId, targetId: targetId });

        if (onClose) onClose();
    };

    return (
        <ConfirmModal
            button={
                <Button variant="outlined" size="small" color="warning" sx={{ py: '0 !important' }}>
                    {t('markAsNoDuplicate')}
                </Button>
            }
            title={t('markAsNoDuplicate')}
            text={t('markAsNoDuplicateConfirmation')}
            onConfirm={onMerge}
        />
    );
};
